import { render, staticRenderFns } from "./familyMemberDetail.vue?vue&type=template&id=4e97a887&scoped=true&"
import script from "./familyMemberDetail.vue?vue&type=script&lang=js&"
export * from "./familyMemberDetail.vue?vue&type=script&lang=js&"
import style0 from "./familyMemberDetail.vue?vue&type=style&index=0&id=4e97a887&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e97a887",
  null
  
)

export default component.exports